"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiValue = void 0;
const class_transformer_1 = require("class-transformer");
/**
 * Transforms value from and to types compatible with AWS multi value parameters. Eg. from comma concatenated string to array and vice versa.
 *
 * @example
 * class Example {
 *   @MultiValue()
 *   public propertyName: string[];
 * }
 *
 * console.log(JSON.stringify(example)); // output: { "propertyName": "value1,value2" }
 */
const MultiValue = () => (target, key) => {
    (0, class_transformer_1.Transform)(({ value }) => typeof value === 'string' ? value.split(',') : Array.isArray(value) ? value : undefined, { toClassOnly: true })(target, key);
    (0, class_transformer_1.Transform)(({ value }) => {
        if (Array.isArray(value) && value.length) {
            return value.join(',');
        }
        if (typeof value === 'string') {
            return value;
        }
        return undefined;
    }, { toPlainOnly: true })(target, key);
};
exports.MultiValue = MultiValue;
